import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Sharing from "../Common/Sharing";

class SharingReisadviezen extends Component {
  static propTypes = {
    config: PropTypes.object,
  };

  render() {
    const { print, mail, whatsapp, logo } = this.props.config;

    let customEmail = {
      buttonText: "",
      subjectText: "",
      messageText: "",
    };

    let customWhatsapp = {
      buttonText: "",
      messageText: "",
    };

    if (print) {
      print.buttonText = this.applyRouteInfoToText(print.buttonText);
    }

    if (mail) {
      customEmail.buttonText = this.applyRouteInfoToText(mail.buttonText);
      customEmail.subjectText = this.applyRouteInfoToText(mail.subjectText);
      customEmail.messageText = this.applyRouteInfoToText(
        mail.messageText,
        true
      );
    }

    if (whatsapp) {
      customWhatsapp.buttonText = this.applyRouteInfoToText(
        whatsapp.buttonText
      );
      customWhatsapp.messageText = this.applyRouteInfoToText(
        whatsapp.messageText,
        true
      );
    }
    return (
      <Sharing
        className="reisadvies__shares"
        print={print}
        mail={customEmail}
        whatsapp={customWhatsapp}
        logo={logo}
      />
    );
  }

  applyRouteInfoToText(text, encodeLink = false) {
    const { origin, destination } = this.props;
    const link = window.location.href;
    return (text || "")
      .replace(/{origin}/g, origin)
      .replace(/{destination}/g, destination)
      .replace(/{link}/g, encodeLink ? encodeURIComponent(link) : link);
  }
}

export default connect((state) => {
  const { origin, destination } = state.reisadviezen;

  return {
    origin: origin ? origin : "?",
    destination: destination ? destination : "?",
  };
}, {})(SharingReisadviezen);



// WEBPACK FOOTER //
// ./src/components/Reisadviezen/Sharing.js